import React, { useEffect } from "react";
import styles from "./topDonorFilters.module.scss";
import HelpMeItemContainer from "../../../HelpMePage/ui/HelpMeItemContainer/HelpMeItemContainer";
import ListPicker from "../../../HelpMePage/ui/ListPicker/ListPicker";
import Selector from "../../../HelpMePage/ui/Selector/Selector";
import {
  BLOOD_CLASES,
  BLOOD_KELLS_FILTERS,
  SHORT_BLOOD_GROUPS_HELP_ME,
} from "../../../../entities";
import RadioSelector from "../../../HelpMePage/ui/RadioSelector/RadioSelector";
import TextInput from "../../../HelpMePage/ui/TextInput/TextInput";
import { observer } from "mobx-react";
import { useStores } from "../../../../hooks/mobx";
import { Modal } from "semantic-ui-react";

type TTopDonorFiltersHeaderCount = {
  count: number;
};

const TopDonorFilters = observer(() => {
  const { topDonorPageStore, uiStore } = useStores();
  const { modalOpen } = topDonorPageStore;

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (typeof document !== "undefined") {
        document.getElementById("maino").style.overflow = modalOpen
          ? "hidden"
          : "initial";
      }
    }
  }, [modalOpen]);

  useEffect(() => {
    if (!uiStore.isMobile) {
      topDonorPageStore.setOpenModal(false);
    }
  }, [uiStore.isMobile]);

  if (modalOpen) {
    return (
      <Modal open={modalOpen} className={styles.TopDonorFiltersModal}>
        <Modal.Header className={styles.TopDonorFiltersModalHeader}>
          <TopDonorFiltersHeader />
        </Modal.Header>
        <Modal.Content
          scrolling={true}
          className={styles.TopDonorFiltersModalContent}
        >
          <TopDonorFiltersContent />
        </Modal.Content>
      </Modal>
    );
  }

  return (
    <div className={styles.TopDonorFilters}>
      <TopDonorFiltersHeader />
      <TopDonorFiltersContent />
    </div>
  );
});

const TopDonorFiltersButtons: React.FC = observer(() => {
  const { topDonorPageStore } = useStores();

  const onUpdateFilters = (e) => {
    e.target?.blur();
    topDonorPageStore.setFilters().then(() => {
      topDonorPageStore.setOpenModal(false);
      if (typeof window !== "undefined") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    });
  };

  const onResetFilters = (e) => {
    e.target?.blur();
    topDonorPageStore.resetFilters();
  };

  return (
    <div className={styles.FiltersButtonContainer}>
      <SetFiltersButton onUpdateFilters={onUpdateFilters} />
      <ResetFiltersButton resetFilters={onResetFilters} />
    </div>
  );
});

const TopDonorFiltersHeader: React.FC = observer(() => {
  const { topDonorPageStore } = useStores();
  const { appliedFiltersCount } = topDonorPageStore;

  const onClickClose = () => {
    topDonorPageStore.setOpenModal(false);
  };

  const onClickClear = () => {
    topDonorPageStore
      .resetFilters()
      .then(() => topDonorPageStore.setOpenModal(false));
  };

  return (
    <div className={styles.TopDonorFiltersHeader}>
      <div
        onClick={onClickClear}
        className={styles.TopDonorFiltersHeader_ClearButton}
      >
        <span>Очистить</span>
      </div>
      <div className={styles.TopDonorFiltersHeader_Title}>
        <span>Фильтры</span>
      </div>
      <div className={styles.TopDonorFiltersHeader_Activity}>
        {!!appliedFiltersCount && (
          <TopDonorFiltersHeaderCount count={appliedFiltersCount} />
        )}
      </div>
      <div
        onClick={onClickClose}
        className={styles.TopDonorFiltersHeader_ActivityMobile}
      >
        <img src="/static/images/icons/close.svg" alt="close" />
      </div>
    </div>
  );
});

const TopDonorFiltersHeaderCount: React.FC<TTopDonorFiltersHeaderCount> = ({
  count,
}) => {
  return (
    <div className={styles.TopDonorFiltersHeaderCount}>
      <span>{count}</span>
    </div>
  );
};

const SEX_TYPES = [
  { value: "male", title: "Мужской" },
  { value: "female", title: "Женский" },
  { value: "any", title: "Любой" },
];

type TTopDonorFiltersContent = {
  noButtons?: boolean;
};

const TopDonorFiltersContent: React.FC<TTopDonorFiltersContent> = observer(
  ({ noButtons = false }) => {
    const { topDonorPageStore } = useStores();
    const {
      currentModelInputData,
      onChangeMultiple,
      onChange,
      pseudoModel,
      placeStore,
    } = topDonorPageStore;

    const onSelectCountry = (item) => {
      onChange("country", item);
    };

    const onSelectRegion = (item) => {
      onChange("region", item);
    };

    const onSelectCity = (item) => {
      onChange("city", item);
    };

    const onSelectBloodStation = (item) => {
      onChange("blood_station_id", item);
    };

    const onSelectOrganization = (item) => {
      onChange("organization_id", item);
    };

    return (
      <div className={styles.TopDonorFiltersContent}>
        <div className={styles.TopDonorFiltersContent_DoubleMobile}>
          <HelpMeItemContainer isSmall={true} title={"Страна"} required={true}>
            <ListPicker
              itemOptions={placeStore.countryOptions}
              getUpdatedItems={placeStore.updateCountryOptions}
              placeholder={"Не выбрано"}
              selectedValue={pseudoModel["country"]}
              onSelect={onSelectCountry}
              customNotFound={"Не найдено"}
              isClearable={true}
            />
          </HelpMeItemContainer>
          <HelpMeItemContainer isSmall={true} title={"Регион"} required={true}>
            <ListPicker
              itemOptions={placeStore.regionOptions}
              getUpdatedItems={(v) =>
                placeStore.updateRegionOptions(v, pseudoModel.country?.value)
              }
              placeholder={"Не выбрано"}
              selectedValue={pseudoModel["region"]}
              onSelect={onSelectRegion}
              customNotFound={"Не найдено"}
              isClearable={true}
            />
          </HelpMeItemContainer>
        </div>
        <div className={styles.TopDonorFiltersContent_DoubleMobile}>
          <HelpMeItemContainer isSmall={true} title={"Город"} required={true}>
            <ListPicker
              itemOptions={placeStore.cityOptions}
              getUpdatedItems={(v) =>
                placeStore.updateCityOptions(
                  v,
                  pseudoModel.country?.value,
                  pseudoModel.region?.value
                )
              }
              placeholder={"Не выбрано"}
              selectedValue={pseudoModel["city"]}
              onSelect={onSelectCity}
              customNotFound={"Не найдено"}
              isClearable={true}
            />
          </HelpMeItemContainer>
          <HelpMeItemContainer
            isSmall={true}
            title={"Центр крови"}
            required={true}
            popupText={
              "Будут учитываться только донации, совершённые в выбранном центре крови"
            }
            popupIcon={"/static/images/top/Info.svg"}
          >
            <ListPicker
              itemOptions={placeStore.bloodStationOptions}
              getUpdatedItems={(v) =>
                placeStore.updateBloodStationOptions(
                  v,
                  pseudoModel.country?.value,
                  pseudoModel.region?.value,
                  pseudoModel.city?.value
                )
              }
              placeholder={"Не выбрано"}
              selectedValue={pseudoModel["blood_station_id"]}
              onSelect={onSelectBloodStation}
              customNotFound={"Не найдено"}
              isClearable={true}
            />
          </HelpMeItemContainer>
        </div>
        {/* <HelpMeItemContainer
          isSmall={true}
          title={"Организация"}
          required={true}
        >
          <ListPicker
            itemOptions={placeStore.organizationOptions}
            getUpdatedItems={(v) =>
              placeStore.updateOrganizationOptions(
                v,
                pseudoModel.country?.value,
                pseudoModel.region?.value,
                pseudoModel.city?.value
              )
            }
            placeholder={"Не выбрано"}
            selectedValue={pseudoModel["organization_id"]}
            onSelect={onSelectOrganization}
            customNotFound={"Не найдено"}
            isClearable={true}
          />
        </HelpMeItemContainer> */}
        <HelpMeItemContainer
          isSmall={true}
          title={"Группа крови"}
          required={true}
        >
          <Selector
            arrayOfObjects={SHORT_BLOOD_GROUPS_HELP_ME}
            value={pseudoModel["blood_group"]}
            multiple
            onChangeMultiple={(value) => onChangeMultiple("blood_group", value)}
            maxColumns={0}
            centered
            alwaysTwo
          />
        </HelpMeItemContainer>
        <div className={styles.TopDonorFiltersContent_DoubleMobile}>
          <HelpMeItemContainer
            isSmall={true}
            title={"kell-фактор"}
            required={true}
          >
            <RadioSelector
              options={BLOOD_KELLS_FILTERS}
              selectorID={"blood_kell"}
              selected={pseudoModel["kell"]}
              onSelect={(value) => onChange("kell", value)}
            />
          </HelpMeItemContainer>
          <HelpMeItemContainer isSmall={true} title={"Пол"} required={true}>
            <RadioSelector
              options={SEX_TYPES}
              selectorID={"sex_type"}
              selected={pseudoModel["gender"]}
              onSelect={(value) => onChange("gender", value)}
            />
          </HelpMeItemContainer>
        </div>
        <HelpMeItemContainer isSmall={true} title={"Возраст"} required={true}>
          <div className={styles.TopDonorFiltersContent_AgeInputs}>
            <TextInput
              isNumber={true}
              value={pseudoModel["age_start"]}
              placeholder={currentModelInputData["age_start"].placeholder}
              onChange={(value) => onChange("age_start", value)}
              fullWidth={true}
              minValue={18}
              maxValue={90}
            />
            -
            <TextInput
              isNumber={true}
              value={pseudoModel["age_end"]}
              placeholder={currentModelInputData["age_end"].placeholder}
              onChange={(value) => onChange("age_end", value)}
              fullWidth={true}
              minValue={18}
              maxValue={90}
            />
          </div>
        </HelpMeItemContainer>
        <HelpMeItemContainer
          isSmall={true}
          title={"Компонент крови"}
          required={true}
          popupText={"Топ построится по количеству выбранных компонентов"}
          popupIcon={"/static/images/top/Info.svg"}
        >
          <Selector
            arrayOfObjects={BLOOD_CLASES}
            value={pseudoModel["components"]}
            multiple
            onChangeMultiple={(value) => onChangeMultiple("components", value)}
            maxColumns={0}
          />
        </HelpMeItemContainer>
        {!noButtons && <TopDonorFiltersButtons />}
      </div>
    );
  }
);

type TResetFiltersButton = {
  resetFilters: (e) => void;
};

const ResetFiltersButton: React.FC<TResetFiltersButton> = observer(
  ({ resetFilters }) => {
    return (
      <div className={styles.ResetFiltersButton}>
        <button onClick={resetFilters}>Сбросить</button>
      </div>
    );
  }
);

type TSetFiltersButton = {
  onUpdateFilters: (e) => void;
};

const SetFiltersButton: React.FC<TSetFiltersButton> = observer(
  ({ onUpdateFilters }) => {
    return (
      <div className={styles.SetFiltersButton}>
        <button onClick={onUpdateFilters}>Применить</button>
      </div>
    );
  }
);

export default TopDonorFilters;
